// removed by extract-text-webpack-plugin
module.exports = {"container":"_3eYDdO2TcdH1L-H3GDpp5W","Email":"_3RKG7D8qYv7nZDhbtlgAxT","Signer":"UfjlLJ_I7paWAFkBSVIXC","Icon":"_213hpg1d0ChnKMPt-__Qgk","Title":"_1ZCcYigxDIqJoQJSdjWBE9"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/DocumentVerify/Main/Verify/Signers/styles.css
// module id = 3003
// module chunks = 0